import clsx from 'clsx';
import { memo, MouseEvent, ReactNode } from 'react';
import { Button } from 'src/modules/common/components/Button/Button.tsx';
import { preventDefault } from 'src/modules/common/utils/preventDefault.ts';

type Props = {
    title?: boolean;
    selected?: boolean;
    onClick?: (e?: MouseEvent<HTMLButtonElement>) => void;
    children: ReactNode;
}

export const OverflowMenuItem = memo(({ title, selected, onClick, children }: Props) => (
    <Button
        type="button"
        kind="ghost"
        className={clsx({
            'vss-overflow-menu-item': true,
            'vss-overflow-menu-item--title': title,
            'vss-overflow-menu-item--selected': selected,
        })}
        onClick={onClick || preventDefault}
    >
        {children}
    </Button>
));
